/* Ikony kart wyboru. Nie są ozdobą — mają nieść to samo znaczenie co etykieta,
   dlatego dobierane są per opcja, a tam gdzie sens jest nieoczywisty (kody wiz,
   lista urzędów) świadomie ich nie ma i wybór idzie listą, nie kartami. */

type IconProps = { size?: number };

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

function Svg({ size = 22, children }: IconProps & { children: React.ReactNode }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {children}
    </svg>
  );
}

export const Icons = {
  briefcase: (p: IconProps) => (
    <Svg {...p}>
      <rect x="3" y="7.5" width="18" height="12.5" rx="2.5" {...stroke} />
      <path d="M9 7.5V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1.5M3 12.5h18" {...stroke} />
    </Svg>
  ),
  contract: (p: IconProps) => (
    <Svg {...p}>
      <path d="M6 3h8l4 4v14H6z" {...stroke} />
      <path d="M14 3v4h4M9 12h6M9 16h4" {...stroke} />
    </Svg>
  ),
  check: (p: IconProps) => (
    <Svg {...p}>
      <path d="m5 12.5 4.5 4.5L19 7.5" {...stroke} />
    </Svg>
  ),
  cross: (p: IconProps) => (
    <Svg {...p}>
      <path d="m7 7 10 10M17 7 7 17" {...stroke} />
    </Svg>
  ),
  idCard: (p: IconProps) => (
    <Svg {...p}>
      <rect x="2.5" y="5" width="19" height="14" rx="2.5" {...stroke} />
      <circle cx="8.5" cy="11" r="2" {...stroke} />
      <path d="M5.5 16c.6-1.6 1.8-2.4 3-2.4s2.4.8 3 2.4M14.5 10h4M14.5 13.5h4" {...stroke} />
    </Svg>
  ),
  passport: (p: IconProps) => (
    <Svg {...p}>
      <rect x="4" y="2.5" width="16" height="19" rx="2.5" {...stroke} />
      <circle cx="12" cy="10" r="3.2" {...stroke} />
      <path d="M9 17h6" {...stroke} />
    </Svg>
  ),
  visa: (p: IconProps) => (
    <Svg {...p}>
      <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" {...stroke} />
      <path d="M2.5 9h19M6.5 13.5h5M6.5 16h3" {...stroke} />
      <circle cx="17" cy="14.5" r="2.5" {...stroke} />
    </Svg>
  ),
  clock: (p: IconProps) => (
    <Svg {...p}>
      <circle cx="12" cy="12" r="8.5" {...stroke} />
      <path d="M12 7.5V12l3 2" {...stroke} />
    </Svg>
  ),
  plane: (p: IconProps) => (
    <Svg {...p}>
      <path d="M3 13.5 21 5l-4 8.5 1 6-3.5-3.5-4 2.5.5-4.5z" {...stroke} />
    </Svg>
  ),
  home: (p: IconProps) => (
    <Svg {...p}>
      <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4v-6h-6v6H5a1 1 0 0 1-1-1z" {...stroke} />
    </Svg>
  ),
  stars: (p: IconProps) => (
    <Svg {...p}>
      <circle cx="12" cy="12" r="8.5" {...stroke} />
      <path d="M12 6.5l.9 1.9 2 .3-1.5 1.4.4 2-1.8-1-1.8 1 .4-2L9.1 8.7l2-.3z" {...stroke} />
    </Svg>
  ),
  calendar: (p: IconProps) => (
    <Svg {...p}>
      <rect x="3.5" y="5" width="17" height="15" rx="2.5" {...stroke} />
      <path d="M3.5 9.5h17M8 3.5v3M16 3.5v3" {...stroke} />
    </Svg>
  ),
  graduation: (p: IconProps) => (
    <Svg {...p}>
      <path d="M12 4 2.5 9 12 14l9.5-5z" {...stroke} />
      <path d="M6.5 11.5V16c0 1.4 2.5 2.5 5.5 2.5s5.5-1.1 5.5-2.5v-4.5" {...stroke} />
    </Svg>
  ),
  building: (p: IconProps) => (
    <Svg {...p}>
      <path d="M4 21V6.5L12 3l8 3.5V21" {...stroke} />
      <path d="M9 21v-5h6v5M8.5 9h2M13.5 9h2M8.5 12.5h2M13.5 12.5h2" {...stroke} />
    </Svg>
  ),
  wallet: (p: IconProps) => (
    <Svg {...p}>
      <rect x="3" y="6" width="18" height="13" rx="2.5" {...stroke} />
      <path d="M3 10h18M16.5 14.5h2" {...stroke} />
    </Svg>
  ),
  shield: (p: IconProps) => (
    <Svg {...p}>
      <path d="M12 3 5 6v6c0 4 3 7.4 7 9 4-1.6 7-5 7-9V6z" {...stroke} />
      <path d="m9 12 2 2 4-4" {...stroke} />
    </Svg>
  ),
  camera: (p: IconProps) => (
    <Svg {...p}>
      <path d="M3 8.5h3l1.5-2.5h9L18 8.5h3v10.5H3z" {...stroke} />
      <circle cx="12" cy="13.5" r="3.5" {...stroke} />
    </Svg>
  ),
  upload: (p: IconProps) => (
    <Svg {...p}>
      <path d="M12 16V4.5M8 8l4-3.5L16 8M4 15v3.5a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V15" {...stroke} />
    </Svg>
  ),
  pin: (p: IconProps) => (
    <Svg {...p}>
      <path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11z" {...stroke} />
      <circle cx="12" cy="10" r="2.6" {...stroke} />
    </Svg>
  ),
  user: (p: IconProps) => (
    <Svg {...p}>
      <circle cx="12" cy="8.5" r="3.6" {...stroke} />
      <path d="M5 20c.9-3.6 3.6-5.4 7-5.4s6.1 1.8 7 5.4" {...stroke} />
    </Svg>
  ),
  accessibility: (p: IconProps) => (
    <Svg {...p}>
      <circle cx="12" cy="5" r="1.8" {...stroke} />
      <path d="M5 9h14M12 9v5m0 0-3 6m3-6 3 6" {...stroke} />
    </Svg>
  ),
  globe: (p: IconProps) => (
    <Svg {...p}>
      <circle cx="12" cy="12" r="8.5" {...stroke} />
      <path d="M3.5 12h17M12 3.5c2.2 2.4 3.3 5.3 3.3 8.5s-1.1 6.1-3.3 8.5c-2.2-2.4-3.3-5.3-3.3-8.5S9.8 5.9 12 3.5z" {...stroke} />
    </Svg>
  ),
  document: (p: IconProps) => (
    <Svg {...p}>
      <path d="M6 3h8l4 4v14H6z" {...stroke} />
      <path d="M14 3v4h4M9 12h6M9 16h6" {...stroke} />
    </Svg>
  ),
  signature: (p: IconProps) => (
    <Svg {...p}>
      <path d="M3 17c3.5 0 3.5-9 6.5-9s2 8 5 8c1.6 0 2.3-1.4 3-2.8M4 20.5h16" {...stroke} />
    </Svg>
  ),
  spark: (p: IconProps) => (
    <Svg {...p}>
      <path d="M12 3.5 13.8 9l5.7 1.8-5.7 1.9L12 18.5l-1.8-5.8L4.5 10.8 10.2 9z" {...stroke} />
    </Svg>
  ),
};

export type IconName = keyof typeof Icons;

/* Mapowanie odpowiedzi na ikonę: najpierw dokładny wybór (pole + opcja),
   potem sam typ pola, potem uniwersalne tak/nie. */
const BY_OPTION: Record<string, IconName> = {
  "forma_wspolpracy:b2b": "briefcase",
  "forma_wspolpracy:zlecenie": "contract",
  "podstawa_pobytu:karta_pobytu": "idCard",
  "podstawa_pobytu:wniosek_karta": "clock",
  "podstawa_pobytu:wiza": "visa",
  "podstawa_pobytu:bezwizowy": "plane",
  "rodzaj_karty_pobytu:staly": "home",
  "rodzaj_karty_pobytu:rezydent_ue": "stars",
  "rodzaj_karty_pobytu:czasowy": "calendar",
  "rodzaj_wizy:krajowa_d": "visa",
  "rodzaj_wizy:schengen_c": "globe",
  "rodzaj_wizy:inna": "document",
  "decyzja_rodzaj_pobytu:czasowy": "calendar",
  "decyzja_rodzaj_pobytu:czasowy_praca": "briefcase",
  "decyzja_rodzaj_pobytu:staly": "home",
  "decyzja_rodzaj_pobytu:rezydent_ue": "stars",
  "uczelnia_stopien:i": "graduation",
  "uczelnia_stopien:ii": "graduation",
  "stopien_niepelnosprawnosci:lekki": "accessibility",
  "stopien_niepelnosprawnosci:umiarkowany": "accessibility",
  "stopien_niepelnosprawnosci:znaczny": "accessibility",
};

const BY_FIELD: Record<string, IconName> = {
  polska_szkola_uczelnia: "graduation",
  studia_stacjonarne: "graduation",
  uczelnia_uprawniona: "graduation",
  absolwent_polskiej_uczelni: "graduation",
  absolwent_polskiej_szkoly: "graduation",
  zaswiadczenie_student: "document",
  zaswiadczenie_obca_szkola: "document",
  fizyczna_legitymacja: "idCard",
  dzialalnosc_gospodarcza: "briefcase",
  inne_zatrudnienie: "building",
  zus_minimalna: "wallet",
  pelny_zus_dg: "wallet",
  emeryt: "user",
  rencista: "user",
  orzeczenie_niepelnosprawnosc: "accessibility",
  ukonczone_26_lat: "user",
  karta_polaka: "idCard",
  zgoda_na_prace: "shield",
  status_ukr: "shield",
  polskie_obywatelstwo: "globe",
  wazna_karta_w_dniu_wniosku: "idCard",
  wazna_wiza_w_dniu_wniosku: "visa",
  student_karta_czasowa: "graduation",
  dostep_do_rynku_pracy: "briefcase",
  zaswiadczenie_uczelnia_wiza: "document",
  dokument_student_obcy_jezyk: "globe",
  oswiadczenie_tlumaczenie: "signature",
};

const BY_VALUE: Record<string, IconName> = { tak: "check", nie: "cross" };

export function iconFor(fieldKey: string, optionId: string): IconName {
  // Najpierw dokładne dopasowanie, potem odpowiedź (tak/nie mówi więcej niż temat
  // pytania — inaczej obie karty dostają tę samą ikonę), na końcu temat pola.
  return (
    BY_OPTION[`${fieldKey}:${optionId}`] ??
    BY_VALUE[optionId] ??
    BY_FIELD[fieldKey] ??
    "spark"
  );
}
